<template>
  <div class="aw-about-us">
    <div class="com-sub-top">
      <div class="title container-center">{{myTitle}}</div>
    </div>
    <div class="tab-box com-desc-box">
        <div class="com-tab-box container-center">
            <div class="p-box">
                <p v-for="item in tabList" :class="{ active: key == item.id }" :key="item.id" @click="choose(item)">{{item.name}}</p>
            </div>
        </div>
    </div>
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  data() {
    return {
        key: '1',
        tabList: [
            {id: '1', name: '企业简介', path: 'desc'},
            {id: '2', name: '联系我们', path: 'contact'},
            {id: '3', name: '加入我们', path: 'join'},
        ]
    };
  },
  methods: {
    choose(val) {
        if(this.key == val.id) return false
        this.key = val.id;
        this.$router.push({ name: val.path });
    },
  },
  computed: {
    myTitle() {
       return this.tabList.find(item => item.id == this.key ).name
    }
  },
  mounted() {
    let map = {desc: '1', contact: '2', join: '3'}
    this.key = map[this.$route.name]
  }
};
</script>